import {Types} from "@Common/types";

import {makeEmptyResultRows} from "./common/utils";

type ByOrdersResult      = Types.Apis.Payloads.Next.Reporting.DeliveryTypeReport.ByOrdersResult;
type ByVolumeResult      = Types.Apis.Payloads.Next.Reporting.DeliveryTypeReport.ByVolumeResult;
type ReportModuleFactory = Types.Xpresso.Account.Admin.Reporting.ActivityDashboard.ReportModuleFactory;

export const makeDeliveryTypeModule:ReportModuleFactory = ({apis}) => ({
    name                : "deliveryType",
    title               : "Delivery Type",
    supportsBranchLevel : true,
    tabs                : ["Orders YTD", "# of Pieces YTD"],
    load                : async ({idBranch, idRegion}) => {
        try {
            const result = await apis.next.reporting.deliveryTypeReport({idBranch, idRegion});
            return [
                result.ordersByDeliveryType.length > 0
                    ? result.ordersByDeliveryType.map(mapOrdersResultAsTabRow)
                    : makeEmptyResultRows({titles: [""]})
                ,
                result.volumeByDeliveryType.length > 0
                    ? result.volumeByDeliveryType.map(mapVolumeResultAsTabRow)
                    : makeEmptyResultRows({titles: [""]})
                ,
            ];
        } catch (error) {
            console.error(error);

            const emptyResultTab = makeEmptyResultRows({titles: [""]});
            return [emptyResultTab, emptyResultTab];
        }
    },
});

const mapOrdersResultAsTabRow = (result:ByOrdersResult) => ({
    content : result.total_orders,
    title   : result.shipping_method,
});

const mapVolumeResultAsTabRow = (result:ByVolumeResult) => ({
    content : result.sum_pieces,
    title   : result.shipping_method,
});

